import {Action, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {storeFreeze} from 'ngrx-store-freeze';
import {routerReducer} from '@ngrx/router-store';
import {environment} from '../../../environments/environment';
import {AuthActionTypes} from '../actions/auth.actions';

export function clearState(reducer: (state: AppState | undefined, action: Action) => AppState) {
    return function(state: AppState | undefined, action: Action) {
        if (action.type === AuthActionTypes.LOGOUT) {
            state = undefined;
        }
        return reducer(state, action);
    };
}

export interface AppState {
}

export const reducers: ActionReducerMap<AppState> = {router: routerReducer};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [storeFreeze, clearState] : [];
